import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  input {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    width: 20px;
    height: 20px;
    appearance: none;
    background-color: #fff;
    color: ${ ({ theme }) => theme.colors.primary};
    border: 2px solid ${ ({ theme }) => theme.colors.primary};
    border-radius: 50%;

    &:disabled {
      border: 1px solid ${ ({ theme }) => theme.colors.grey};
    }
  }

  input::before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em ${ ({ theme }) => theme.colors.primary};
  }

  input:checked::before {
    transform: scale(1);
  }

  label {
    cursor: pointer;

    span {
      color: ${ ({ theme }) => theme.colors.greyMedium};
      font-size: 12px;
    }
  }
}
`